import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import Spin from "antd/es/spin";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { DateRange } from "react-date-range";

type Permission = { id: number; name: string };
type Admin = {
  id: number;
  username: string;
  total_calls: number;
  total_duration: string;
  students_connected: number;
  total_answered_calls_by_agent: number;
  total_answered_calls_by_parent: number;
  total_missed_calls_by_agent: number;
  total_missed_calls_by_parent: number;
  last_call_date: string | null;
};

const WizklubAgentWiseInputs = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const data = exam;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [admin, setAdmin] = useState<Admin[]>([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState<number>();
  const [totalCount, setTotalCount] = useState();
  const [toastMessage, setToastMessage] = useState("");
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const [showDateRange, setShowDateRange] = useState(false);
  const [showCalendar1, setShowCalendar1] = useState(false);

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(new Date().setHours(0, 0, 0, 0)),
      endDate: new Date(new Date().setHours(0, 0, 0, 0)),
      key: "selection",
    },
  ]);

  const startDate = format(dateRange[0].startDate, "yyyy-MM-dd");
  const endDate = format(dateRange[0].endDate, "yyyy-MM-dd");

  useEffect(() => {
    if (!checkPermission("view_wizklub_agent_report", "Records")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData(
        currentPage,
        pageSize,
        searchText,
      );
    }
  }, [userPermissions]);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const handleFetchData = () => {
    if (startDate && endDate) {
      fetchData(currentPage, pageSize, searchText, startDate, endDate); // Call fetchData with date range
      setShowCalendar1(false); // Hide the date range picker after selecting dates
    }
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchGroupsData = async (
    page: number,
    pageSize: number,
    searchText: string,
    startDate = "",
    endDate = ""
  ) => {
    const response = await fetch(
      `${webApi}/wizklub/wizklub_agent_wise_input/?page=${page}&page_size=${pageSize}&search=${searchText}`,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  const fetchPermissionsData = async () => {
    const resposne = await fetch(
      `${webApi}/user/get_permissions_dropdown/`,
      options
    );
    return await resposne.json();
  };

  const fetchData = async (
    page: number,
    pageSize: number,
    searchText: string,
    startDate = "",
    endDate = ""
  ) => {
    setIsLoading(true); // Start loading
    try {
      const [groupsData] = await Promise.all([
        fetchGroupsData(page, pageSize, searchText),
        // fetchPermissionsData(),
      ]);
      setTotalPages(groupsData.total_pages);
      setAdmin(groupsData.results);
      // setPermissions(permissionsData.results);

      setFrom(groupsData.from);
      setTo(groupsData.to);
      setTotalCount(groupsData.total_count);
      setToastMessage(groupsData.message || "submitted successfully!");
      setShowSuccessToast(true);
      setTotalCount(groupsData.total_count);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
    fetchData(
      current,
      pageSize,
      searchText,
      startDate || undefined,
      endDate || undefined
    ); // Fetch new data based on the updated pagination
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    fetchData(
      currentPage,
      pageSize,
      value,
      startDate || undefined,
      endDate || undefined
    );
  };

  const columns = [

    {
      title: "Agent",
      dataIndex: "username",
      // render: (
      //   text:
      //     | string
      //     | number
      //     | boolean
      //     | React.ReactElement<any, string | React.JSXElementConstructor<any>>
      //     | Iterable<React.ReactNode>
      //     | React.ReactPortal
      //     | null
      //     | undefined,
      //   record: { id: any }
      // ) => (
      //   <Link
      //     to={routes.wizklubAgentBranchReports}
      //     state={{ id: record.id, startDate, endDate }}
      //   >
      //     {text}
      //   </Link>
      // ),
    },
    {
      title: "Branches",
      dataIndex: "no_of_branches",
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
        <Link
          to={`${routes.WizklubAgentWiseBranchInputs}?id=${record.id}&startDate=${startDate}&endDate=${endDate}`}
        >
          {text}
        </Link>

      ),
    },
    {
      title: "Unique Student Touch",
      dataIndex: "unique_lead_touch",
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
         <Link
          to={`${routes.WizklubUniqueLeadTouchInputs}?id=${record.id}&startDate=${startDate}&endDate=${endDate}`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Unique Student Touch Connected",
      dataIndex: "unique_lead_touch_connected",
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
         <Link
          to={`${routes.WizklubUniqueLeadTouchConnectedInputs}?id=${record.id}&startDate=${startDate}&endDate=${endDate}`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Calls",
      dataIndex: "no_of_calls",
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
         <Link
          to={`${routes.WizklubNoOfCallsInputs}?id=${record.id}&startDate=${startDate}&endDate=${endDate}`}
        >
          {text}
        </Link>
      ),
    },

    {
      title: "Connected Calls",
      dataIndex: "no_of_call_connected",
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
         <Link
          to={`${routes.WizklubCallsConnected}?id=${record.id}&startDate=${startDate}&endDate=${endDate}`}
        >
          {text}
        </Link>
      ),
    },

    {
      title: "Less than 30 Seconds",
      dataIndex: "less_than_30_secs",
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
         <Link
          to={`${routes.WizklubCallLessThan30Seconds}?id=${record.id}&startDate=${startDate}&endDate=${endDate}`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Less than 1 Minute",
      dataIndex: "less_than_1_min",
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
         <Link
          to={`${routes.WizklubCallLessThan1Minute}?id=${record.id}&startDate=${startDate}&endDate=${endDate}`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Less than 1 Min 30 Secs",
      dataIndex: "less_than_1_min_30_secs",
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
         <Link
          to={`${routes.WizklubCallLessThan1Minute30Seconds}?id=${record.id}&startDate=${startDate}&endDate=${endDate}`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Greater than 1 Min 30 Secs",
      dataIndex: "greater_than_1_min_30_secs",
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { id: any }
      ) => (
         <Link
          to={`${routes.WizklubCallsGreaterThan1Minute30Seconds}?id=${record.id}&startDate=${startDate}&endDate=${endDate}`}
        >
          {text}
        </Link>
      ),
    },
  ];

  const [loading, setLoading] = useState(false);

  const handleExportClick = async () => {

    window.location.href = `${webApi}/exports/export_wizklub_agent_inputs/?token=${jwtToken}&search=${searchText}`


  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Agent Inputs</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard1}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Agent Inputs
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {checkPermission("can_export_wizklub_agent_inputs", "Exports") && (
                <button className="btn btn-primary me-2" onClick={handleExportClick} disabled={loading}>
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    "Export"
                  )}
                </button>
              )}

            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Wizklub Inputs</h4>
              <div
                className="d-flex align-items-center flex-wrap"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >

              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* <div
                className="serch-global text-right"
                style={{ marginRight: "15px" }}
              >
                <input
                  type="search"
                  className="form-control form-control-sm mb-3 w-auto float-end"
                  value={searchText}
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                  aria-controls="DataTables_Table_0"
                ></input>
              </div> */}
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={admin}
                  Selection={false}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    locale: { items_per_page: "" },
                    nextIcon: <span>Next</span>,
                    prevIcon: <span>Prev</span>,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    total: totalCount,
                    showTotal: (total: any, range: any[]) =>
                      `${range[0]}-${range[1]} of ${total}`,
                    pageSizeOptions: ["15", "25", "50", "100"],
                  }}
                  onChange={handleTableChange} // Move this outside of pagination
                  onSearch={handleSearch}
                  searchText={searchText} 
                />
              )}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      <>
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>
    </div>
  );
};

export default WizklubAgentWiseInputs;
